import React from "react";

export const AlertIcon = (props) => {
  return (
    <>
      <svg
        width={21}
        height={18}
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.78149 0.95728L0.269352 15.017C0.0938516 15.3177 0.000990564 15.6587 7.88114e-06 16.0059C-0.000974802 16.3531 0.0899551 16.6946 0.263751 16.9963C0.437547 17.2979 0.688151 17.5493 0.990631 17.7254C1.29311 17.9015 1.63692 17.9962 1.98786 18H19.0121C19.3631 17.9962 19.7069 17.9015 20.0094 17.7254C20.3118 17.5493 20.5625 17.2979 20.7362 16.9963C20.91 16.6946 21.001 16.3531 21 16.0059C20.999 15.6587 20.9061 15.3177 20.7306 15.017L12.2185 0.95728C12.0393 0.665054 11.7871 0.423446 11.4861 0.255768C11.1851 0.0880891 10.8454 0 10.5 0C10.1546 0 9.81494 0.0880891 9.51392 0.255768C9.21291 0.423446 8.96065 0.665054 8.78149 0.95728Z"
          fill="#FECE72"
          style={{
            fill: "#FECE72",
            fill: "color(display-p3 0.9955 0.8090 0.4470)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M10.502 6.06836V10.0457"
          stroke="white"
          style={{
            stroke: "white",
            strokeOpacity: 1,
          }}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.502 14.0234H10.5169"
          stroke="white"
          style={{
            stroke: "white",
            strokeOpacity: 1,
          }}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
